"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'dblogs.filter.dateFrom': 'Date From',
    'dblogs.filter.dateTo': 'Date To',
    'dblogs.filter.models': 'Models',
    'dblogs.filter.models.placeholder': 'All models',
    'dblogs.filter.operations': 'Operations',
    'dblogs.filter.operations.placeholder': 'All operations',
    'dblogs.filter.recordIds': 'Record IDs',
    'dblogs.filter.recordIds.placeholder': 'Add value with Enter',
    'dblogs.filter.search': 'Search',
};
